import { useState, useEffect, useRef } from 'react'

/**
 * Check if an element is visible in the viewport
 * @param {number} [threshold=0.1] - The percentage (0 to 1) of the element's visibility required to consider it visible.
 **/
export const useIsElementVisible = <T extends Element>(threshold: number = 0.1) => {
  const [isVisible, setIsVisible] = useState(false)
  const elementRef = useRef<T | null>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting)
      },
      {
        threshold,
      }
    )

    if (elementRef.current) {
      observer.observe(elementRef.current)
    }

    return () => {
      if (elementRef.current) {
        // #ToDo Fis warning: The ref value 'elementRef.current' will likely have changed by the time this effect cleanup function runs. If this ref points to a node rendered by React, copy 'elementRef.current' to a variable inside the effect, and use that variable in the cleanup function
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(elementRef.current)
      }
    }
  }, [threshold])

  return { isVisible, elementRef }
}
